<template>
  <Paginator v-model="page" v-if="totalPages && totalPages > 1"
            :page-count="totalPages"
            :first-last-button="false"
            :prev-text="'Anterior'"
            :next-text="'Próximo'"
            :page-range="5"
            :hide-prev-next="true"
            :click-handler="pagination"
            :container-class="'pagination container'"
            :page-class="'page-item2'"
            :page-link-class="'page-link2'"
            :active-class="'active-class2'"
            :next-class="'page-item2'"
            :next-link-class="'page-link2'"
            :prev-class="'page-item2'"
            :prev-link-class="'page-link2'">
  </Paginator>
</template>

<script>
  import Paginator from 'vuejs-paginate'

  export default {
    components: { Paginator },
    data() {
      return {
        internalChange: true,
        page: this.value
      }
    },
    methods: {
      pagination(value) {
        this.$emit('pagination', value)
      }
    },
    name: 'Pagination',
    props: {
      totalCount: { type: Number },
      totalPages: { type: Number },
      value: { type: Number },
    },
    watch: {
      page(newValue){
        if (this.internalChange)
          this.$emit('input', newValue)
        else
          this.internalChange = false
      },
      value(newValue) {
        this.internalChange = false
        this.page = newValue
      }
    }
  }
</script>

<style scoped>
  .container {
    width: fit-content;
  }

</style>
